import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { EventPublicCard } from './EventPublicCard';

export function EventSection({
  title, events, viewAllHref, scrollable = false, live = false,
  filters, emptyMessage,
}) {
  return (
    <div>
      {/* Header — título, filtros (opcional, centralizados entre título e
          "Ver todos" a partir do md) e "Ver todos" na mesma linha. Abaixo
          do md, os filtros descem pra uma segunda linha com rolagem
          horizontal própria (ver CategoryFilter). */}
      <div className="mb-6">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-2.5 flex-shrink-0">
            {live && (
              <span className="relative flex h-2.5 w-2.5 flex-shrink-0">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-500 opacity-75" />
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-emerald-500" />
              </span>
            )}
            <h2 className="text-2xl font-bold tracking-tight whitespace-nowrap">{title}</h2>
          </div>

          {filters && (
            <div className="hidden md:flex flex-1 justify-center min-w-0">
              {filters}
            </div>
          )}

          {viewAllHref && (
            <Link
              to={viewAllHref}
              className="flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground transition-colors flex-shrink-0"
            >
              Ver todos <ArrowRight className="w-3.5 h-3.5" />
            </Link>
          )}
        </div>

        {filters && (
          <div className="md:hidden mt-3">
            {filters}
          </div>
        )}
      </div>

      {/* Conteúdo */}
      {events.length === 0 && emptyMessage ? (
        <p className="text-sm text-muted-foreground py-6">{emptyMessage}</p>
      ) : scrollable ? (
        <div className="flex gap-5 overflow-x-auto pb-3 -mx-4 px-4 snap-x snap-mandatory scrollbar-hide">
          {events.map((event) => (
            <div key={event.id} className="flex-shrink-0 w-72 snap-start">
              <EventPublicCard event={event} />
            </div>
          ))}
        </div>
      ) : (
        /* Grid — cap em 4 colunas (sem 2xl:grid-cols-5): com o container
           mais largo da Landing, 4 colunas rendem cards maiores em vez de
           mais colunas espremidas, reduzindo a sensação de espaço vazio. */
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {events.map((event) => (
            <EventPublicCard key={event.id} event={event} />
          ))}
        </div>
      )}
    </div>
  );
}
